<template>
	<b-container>
		<b-row class="mt-3">
			<b-col cols="12">
				<h1>Job: {{ job.Id }} - Quote</h1>
			</b-col>
		</b-row>

		<b-row class="mt-3">
			<b-col cols="12">
				<h4>Dates and revisions</h4>

				<p v-if="quote.ParentQuote">
					Original Quote:
					{{ formatDate(quote.ParentQuote.Sent) }}
				</p>
				<p v-else-if="quote.Sent">
					Original Quote:
					{{ formatDate(quote.Sent) }}
				</p>

				<p>Revised: {{ formatDate(quote.Added) }}</p>
			</b-col>

			<b-col cols="12" class="mt-3 mb-3">
				<h4>Quote Contact</h4>
				<p>{{ job.Contact.Name }}</p>
				<p>{{ job.Contact.Telephone }}</p>
				<p>{{ job.Contact.EmailAddress }}</p>
				<p>{{ job.Contact.Address.Address1 }}</p>
				<p>{{ job.Contact.Address.Address2 }}</p>
				<p>{{ job.Contact.Address.Address3 }}</p>
				<p>{{ job.Contact.Address.Town }}</p>
				<p>{{ job.Contact.Address.County }}</p>
				<p>{{ job.Contact.Address.Postcode }}</p>
			</b-col>

			<b-col cols="12" class="mt-3 mb-3">
				<h4>Intro and report</h4>
				<span v-html="quote.Introduction"></span>
			</b-col>

			<b-col
				cols="12"
				class="mt-3 mb-3"
				v-for="(block, index) in quoteBlocks"
				:key="index"
			>
				<b-col cols="11" class="mb-3">
					{{ block.Title }}
				</b-col>

				<b-col class="mt-3">
					<h4>Attend on site</h4>

					<b-row
						class="mt-3 mb-3"
						v-for="(line, lineIndex) in quoteBlocks[index]
							.QuoteLines[0]"
						:key="`${lineIndex}-0`"
					>
						<b-col cols="9">
							{{ line.Title }} - {{ line.Order }}
						</b-col>

						<b-col>
							{{ line.Hours }}
						</b-col>
					</b-row>
				</b-col>

				<b-col class="mt-3">
					<h4>In our workshop</h4>

					<b-row
						class="mt-3 mb-3"
						v-for="(line, lineIndex) in quoteBlocks[index]
							.QuoteLines[1]"
						:key="`${lineIndex}-1`"
					>
						<b-col cols="9">
							{{ line.Title }} - {{ line.Order }}
						</b-col>

						<b-col>
							{{ line.Hours }}
						</b-col>
					</b-row>
				</b-col>

				<b-col class="mt-3">
					<h4>Return to site</h4>

					<b-row
						class="mt-3 mb-3"
						v-for="(line, lineIndex) in quoteBlocks[index]
							.QuoteLines[2]"
						:key="`${lineIndex}-2`"
					>
						<b-col cols="9">
							{{ line.Title }} - {{ line.Order }}
						</b-col>

						<b-col>
							{{ line.Hours }}
						</b-col>
					</b-row>
				</b-col>

				<b-col cols="12" class="mt-3 mb-3">
					<p>
						For the sum of: &pound;{{
							block.Cost | localNumber
						}}
						[{{ block.Cost | toWords }} pounds] net plus VAT.
					</p>
				</b-col>
			</b-col>

			<b-col cols="12" class="mt-3 mb-3">
				<h4>Quote terms will be added here</h4>
			</b-col>

			<b-col cols="12" class="mt-3 mb-3">
				<h4>Exclusions and notes</h4>
				<span v-html="quote.Exclusions"></span>
			</b-col>

			<b-col cols="12">
				<pre>{{ quote.SignatureUser.SignatureBlock }}</pre>
			</b-col>

			<b-col cols="6">
				<image-asset
					:asset="quote.SignatureUser.SignatureImage"
					:relate="quote.ApplicationUserId"
					type="1"
					folder="ApplicationUser"
					direction="down"
				/>
			</b-col>
		</b-row>
	</b-container>
</template>

<script>
import QuoteService from "@/api-services/quote.service";
import JobService from "@/api-services/job.service";
import ImageAsset from "@/components/partials/image-asset";

import { dateFuncs } from "@/globs.js";
import converter from "number-to-words";

export default {
	name: "quoteLayout",

	props: ["quoteId"],

	components: {
		ImageAsset
	},
	data() {
		return {
			quote: {
				Added: dateFuncs.today(),
				SignatureUser: {}
			},

			job: {
				Contact: {
					Address: {}
				}
			},

			quoteBlocks: []
		};
	},

	created() {
		this.fetchQuote();
	},

	filters: {
		toWords(value) {
			if (!value) return "";
			return converter.toWords(value);
		},

		localNumber(value) {
			return Number(value).toLocaleString();
		}
	},

	methods: {
		fetchQuote() {
			QuoteService.get(this.quoteId).then(response => {
				this.quote = response.data;

				if (response.data.JobId) {
					this.fetchJob();
				}

				this.quote.QuoteBlocks.forEach((quoteBlock, blockIndex) => {
					if (!this.quoteBlocks[blockIndex]) {
						this.addBlock();
					}
					this.quoteBlocks[blockIndex].Id = quoteBlock.Id;
					this.quoteBlocks[blockIndex].Title = quoteBlock.Title;
					this.quoteBlocks[blockIndex].Cost = quoteBlock.Cost;

					quoteBlock.QuoteLines.forEach(quoteLine => {
						// push them into the correct array for it's type
						this.quoteBlocks[blockIndex].QuoteLines[
							quoteLine.TaskType
						].push(quoteLine);
					});

					// order each tasktype block by line order...
					this.quoteBlocks[blockIndex].QuoteLines.forEach((quoteTaskTaskType) => {
						quoteTaskTaskType.sort((a, b) => {
							return a.Order - b.Order;
						});
					});

				});
			});
		},

		fetchJob() {
			JobService.get(this.quote.JobId).then(response => {
				this.job = response.data;
			});
		},

		addBlock() {
			this.quoteBlocks.push({
				Title: "",
				Cost: 0,
				QuoteLines: [[], [], []]
			});
		},

		addLine(index, taskType) {
			// push to correct array.
			this.quoteBlocks[index].QuoteLines[taskType].push({
				Title: "",
				Hours: 0,
				TaskType: taskType
			});
		},

		formatDate(date) {
			return dateFuncs.humanDateFormat(date);
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/quote/quote-layout.vue